import { createAppSlice } from '../../app/createAppSlice'

const initialState = {
    foiFocus: "",
    trackingOn: false
};

const foiOfFocusSlice = createAppSlice({
    name: "foiOfFocus",
    initialState,
    reducers: create => ({
        changeFoiFocus: create.reducer((state, action) => {
            state.foiFocus = action.payload
        }),
        trackingIsOn: create.reducer((state) => {
            state.trackingOn = true;
        }),
        trackingIsOff: create.reducer((state) => {
            state.trackingOn = false;
        }),
    }),
    selectors: {
        selectFoiFocus: foiOfFocus => foiOfFocus.foiFocus,
        selectTrackingOn: foiOfFocus => foiOfFocus.trackingOn
    },
})

export const {changeFoiFocus, trackingIsOn, trackingIsOff } = foiOfFocusSlice.actions

export const { selectFoiFocus, selectTrackingOn } = foiOfFocusSlice.selectors

export default foiOfFocusSlice